"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaQueries = void 0;
var mediaWidth = function (size) {
    return window.getComputedStyle(document.documentElement).getPropertyValue("--data-media-" + size);
};
var maxWidth = function (width) {
    return "(max-width: " + width + ")";
};
var MediaQueries = {
    s: maxWidth(mediaWidth('s')),
    m: maxWidth(mediaWidth('m')),
    l: maxWidth(mediaWidth('l')),
    xl: maxWidth(mediaWidth('xl')),
};
exports.MediaQueries = MediaQueries;
//# sourceMappingURL=MediaQueries.js.map